import React from "react";
import PropTypes from "prop-types";

import "./GradientOverflowContainer.scss";

const GradientOverflowContainer = ({ className, children }) => (
	<div className={`gradient-overflow-container ${className}`}>
		<div className={`gradient-overflow-container-inner ${className}-inner`}>
			<div
				className={`gradient-overflow-container-child-container ${className}-child-container`}
				data-scrollcontainer="1"
			>
				{children}
			</div>
		</div>
	</div>
);
GradientOverflowContainer.propTypes = {
	className: PropTypes.string,
	children: PropTypes.any.isRequired,
};
GradientOverflowContainer.defaultProps = {
	className: "",
};

export default GradientOverflowContainer;



// WEBPACK FOOTER //
// ./src/shared/components/GradientOverflowContainer.jsx